import { ActionStatus } from '@/application/types';
import { OrderSearchState } from '../types';

export const orderSearchStateDefaults: OrderSearchState = {
  hasSearchBeenTriggered: false,
  hasSearchResultedIn0Results: false,
  lastSearchTerm: '',
  orderIdentifications: [],
  currentOrderId: null,
  currentOrder: null,
  getOrderIdentificationsByOrderNumberStatus: ActionStatus.None,
  getCurrentOrderStatus: ActionStatus.None,
};
